"use client";

import { YogaSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedYogaSection from "../Components/GeneratedYogaSection";

const Yoga: FC<YogaSectionProps> = (props) => {
  return <GeneratedYogaSection {...props} />;
};

export default Yoga;
